document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.lm-collection-tabs-section');

  sections.forEach((section) => {
    const tabsWrap = section.querySelector('.lm-collection-tabs__tabs-wrap');
    const tabs = section.querySelector('[data-tabs]');
    const triggers = section.querySelectorAll('[data-tab-trigger]');
    const panels = section.querySelectorAll('[data-tab-panel]');

    if (!tabs || !triggers.length || !panels.length) return;

    // ── Tabs fade ─────────────────────────────────────────────
    const updateTabsFade = () => {
      if (!tabsWrap) return;
      const maxScrollLeft = tabs.scrollWidth - tabs.clientWidth;
      const hasOverflow = tabs.scrollWidth > tabs.clientWidth + 2;
      const isAtEnd = tabs.scrollLeft >= maxScrollLeft - 4;
      tabsWrap.classList.toggle('has-overflow', hasOverflow);
      tabsWrap.classList.toggle('is-end', isAtEnd);
    };

    const activateTab = (targetId) => {
      triggers.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.target === targetId);
      });
      panels.forEach((panel) => {
        const isActive = panel.id === targetId;
        panel.classList.toggle('is-active', isActive);
      });

      const activePanel = section.querySelector(`#${targetId}`);
      if (activePanel) {
        const slider = activePanel.querySelector('[data-product-slider]');
        if (slider) {
          slider.scrollLeft = 0;
          updateSliderUI(activePanel);
        }
      }
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const targetId = trigger.dataset.target;
        activateTab(targetId);
        trigger.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    tabs.addEventListener('scroll', updateTabsFade);
    window.addEventListener('resize', updateTabsFade);
    updateTabsFade();

    // ── Slider: flechas + puntos de progreso ──────────────────
    const ARROW_SVG_PREV = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 3L5 8L10 13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    const ARROW_SVG_NEXT = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    const getScrollStep = (slider) => slider.clientWidth * 0.85;

    const getActiveDotIndex = (slider, total) => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 0 || total <= 1) return 0;
      return Math.round((slider.scrollLeft / maxScroll) * (total - 1));
    };

    const updateSliderUI = (panel) => {
      const slider = panel.querySelector('[data-product-slider]');
      const prevBtn = panel.querySelector('.lm-slider-arrow--prev');
      const nextBtn = panel.querySelector('.lm-slider-arrow--next');
      const dots = panel.querySelectorAll('.lm-slider-progress__dot');

      if (!slider) return;

      const maxScroll = slider.scrollWidth - slider.clientWidth;
      const hasOverflow = maxScroll > 2;
      const scrollLeft = slider.scrollLeft;

      if (prevBtn) prevBtn.classList.toggle('is-hidden', scrollLeft <= 2);
      if (nextBtn) nextBtn.classList.toggle('is-hidden', !hasOverflow || scrollLeft >= maxScroll - 2);

      if (dots.length) {
        const activeIndex = getActiveDotIndex(slider, dots.length);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      }
    };

    const buildDots = (panel, progressWrap) => {
      const slider = panel.querySelector('[data-product-slider]');
      if (!slider) return;

      const maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 2) {
        progressWrap.innerHTML = '';
        return;
      }

      const total = Math.max(2, Math.round(slider.scrollWidth / slider.clientWidth));
      progressWrap.innerHTML = Array.from({ length: total })
        .map(() => '<span class="lm-slider-progress__dot"></span>')
        .join('');

      updateSliderUI(panel);
    };

    panels.forEach((panel) => {
      const sliderWrap = panel.querySelector('.lm-collection-tabs__slider-wrap');
      const slider = panel.querySelector('[data-product-slider]');
      if (!sliderWrap || !slider) return;

      const prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'lm-slider-arrow lm-slider-arrow--prev is-hidden';
      prevBtn.setAttribute('aria-label', 'Anterior');
      prevBtn.innerHTML = ARROW_SVG_PREV;

      const nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'lm-slider-arrow lm-slider-arrow--next';
      nextBtn.setAttribute('aria-label', 'Siguiente');
      nextBtn.innerHTML = ARROW_SVG_NEXT;

      sliderWrap.appendChild(prevBtn);
      sliderWrap.appendChild(nextBtn);

      const progressWrap = document.createElement('div');
      progressWrap.className = 'lm-slider-progress';
      panel.appendChild(progressWrap);

      setTimeout(() => buildDots(panel, progressWrap), 100);
      window.addEventListener('resize', () => buildDots(panel, progressWrap));

      prevBtn.addEventListener('click', () => {
        slider.scrollBy({ left: -getScrollStep(slider), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        slider.scrollBy({ left: getScrollStep(slider), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', () => updateSliderUI(panel));
    });
  });
});